<template>
    <list class="tracker-list"
          :list="list"
          :infiniteId="infiniteId"
          :headers="headers"
          :loading="loading"
          @load="load">
      <template slot="default"
                slot-scope="slotProps">
        <tracker-list-item :item="slotProps.item"
                                   @reload="emitReload" />
      </template>
    </list>
  </template>
  
<script>
import List from "@components/generic/list/List.vue";
import TrackerListItem from "./item/TrackerListItem.vue";
  
export default {
    components: {
      List,
      TrackerListItem
    },
  
    data() {
      return {
        loading: false,       
        list: [],        
      };
    },
  
  
    props: {
      infiniteId: {
        type: Number,
        required: true,
      },
    },

    computed: {
        headers() {
            return [
                {text: "", value: "", sortable: false, width: "5px"},
                { text: "Nome", value: "name", sortable: false },
                { text: "Tipo", value: "type", sortable: false },        
            ]
        },
        filters() {
            return this.$store.state.trackers.filters.search;
        },
    },
  
    methods: {
      async load($state) {
        try {         
          const trackersList = await this.$api.core.trackers.list({
            type: "FACEBOOK_PIXEL",
            name: this.filters
          });
  
          this.list = trackersList;
          
          $state.complete();
        } catch (error) {
          console.log(error);
        }
      },
      emitReload() {
        this.$emit("reload");
      },
      
    },
    
  };
</script>
  
<style lang="scss" scoped>
  .tracker-list {
    ::v-deep .v-table__overflow {
      overflow: visible;
    }
  }
</style>